import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as FileTextIcon } from './fileText.svg';

export const FileText = IconHOC(FileTextIcon);
